import { render, staticRenderFns } from "./UploadBlock.vue?vue&type=template&id=a954c488&scoped=true&"
import script from "./UploadBlock.vue?vue&type=script&lang=js&"
export * from "./UploadBlock.vue?vue&type=script&lang=js&"
import style1 from "./UploadBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a954c488",
  null
  
)

export default component.exports